@if(showToast) {
  <div class="fixed top-0 inset-x-0 z-50 flex justify-center animate-slide-down">
    <div class="w-full max-w-lg mx-4 mt-3 rounded-xl shadow-2xl overflow-hidden"
      [ngClass]="{
        'bg-amber-50 border border-amber-300': urgency === 'warning',
        'bg-orange-50 border border-orange-400': urgency === 'danger',
        'bg-red-50 border border-red-400': urgency === 'critical'
      }">

      <!-- Progress bar -->
      <div class="h-1 bg-gray-200">
        <div class="h-full transition-all duration-1000 ease-linear rounded-full"
          [ngClass]="{
            'bg-amber-400': urgency === 'warning',
            'bg-orange-500': urgency === 'danger',
            'bg-red-500': urgency === 'critical'
          }"
          [style.width.%]="progress">
        </div>
      </div>

      <div class="px-4 py-3 flex items-center gap-3">
        <!-- Icon -->
        <div class="flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center"
          [ngClass]="{
            'bg-amber-100 text-amber-600': urgency === 'warning',
            'bg-orange-100 text-orange-600': urgency === 'danger',
            'bg-red-100 text-red-600': urgency === 'critical'
          }">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
          </svg>
        </div>

        <!-- Text -->
        <div class="flex-1 min-w-0">
          <p class="text-sm font-semibold"
            [ngClass]="{
              'text-amber-800': urgency === 'warning',
              'text-orange-800': urgency === 'danger',
              'text-red-800': urgency === 'critical'
            }">
            Sesión por expirar
          </p>
          <p class="text-xs"
            [ngClass]="{
              'text-amber-600': urgency === 'warning',
              'text-orange-600': urgency === 'danger',
              'text-red-600': urgency === 'critical'
            }">
            Se cerrará en <b>{{ seconds }}</b> segundo{{ seconds !== 1 ? 's' : '' }} por inactividad
          </p>
        </div>

        <!-- Button -->
        <button (click)="keepWorking()"
          class="flex-shrink-0 px-3 py-1.5 text-xs font-semibold rounded-lg transition-colors cursor-pointer"
          [ngClass]="{
            'bg-amber-500 hover:bg-amber-600 text-white': urgency === 'warning',
            'bg-orange-500 hover:bg-orange-600 text-white': urgency === 'danger',
            'bg-red-500 hover:bg-red-600 text-white': urgency === 'critical'
          }">
          Seguir trabajando
        </button>
      </div>
    </div>
  </div>
}
